var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { clearProps, SPACING_M, SPACING_S } from "../../helpers";
import { Icon, ICON_SIZES } from "../../Icon";
import { STACK_ALIGN, STACK_GAP, StackView } from "../../StackView";
import { Text, TEXT_VIEW } from "../../Text";
var StyledStackView = styled(StackView)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", ";\n    text-decoration: none;\n    cursor: pointer;\n\n    ", "\n\n    ", "\n"], ["\n    padding: ", " ", ";\n    text-decoration: none;\n    cursor: pointer;\n\n    ",
    "\n\n    ",
    "\n"])), SPACING_S, SPACING_M, function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        background-color: ", ";\n\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    "], ["\n        color: ", ";\n        background-color: ", ";\n\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    "])), theme.colorTextHeader, theme.colorBackgroundHeader, theme.colorHeaderTabHover, theme.colorHeaderTabActive);
}, function (_a) {
    var theme = _a.theme, active = _a.active;
    return active && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            color: ", ";\n\n            &,\n            &:hover,\n            &:active {\n                background-color: ", ";\n            }\n        "], ["\n            color: ", ";\n\n            &,\n            &:hover,\n            &:active {\n                background-color: ", ";\n            }\n        "])), theme.colorTextMain, theme.colorHeaderTabCurrent);
});
export var AppBarLink = function (_a) {
    var text = _a.text, icon = _a.icon, url = _a.url, active = _a.active, rest = __rest(_a, ["text", "icon", "url", "active"]);
    return (React.createElement(StyledStackView, __assign({ asTag: "a", testId: "appbar-link", active: active, align: STACK_ALIGN.center, gap: STACK_GAP.s }, clearProps(rest, { href: url })),
        icon && React.createElement(Icon, { src: icon, size: ICON_SIZES.xl }),
        text && React.createElement(Text, { view: TEXT_VIEW.inherit }, text)));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AppBarLink.js.map